module.exports = __webpack_public_path__ + "static/media/frontlogow.58a75eb2.svg";